import { SiteLingualityKind } from '@src/config/shell/localConfigTypes';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { getConfig } from '@superbet-group/web.lib.config';
import { getCookie } from '@app/utils/cookieHelpers';
import { Locale } from '@superbet-group/web.types';
import { appLocale } from '@src/config/locale';

export function checkIfHasLanguageSwitcher(kind: SiteLingualityKind, isProdEnv: boolean): boolean {
    return kind === SiteLingualityKind.MultiLingual
        || !isProdEnv;
}

const siteLanguageConfig = shellLocalConfig.siteLanguageConfig;
const hasLanguageSwitcher = checkIfHasLanguageSwitcher(siteLanguageConfig.kind, getConfig().environment.isProdEnvironment);
const isMultiLingualSite = siteLanguageConfig.kind === SiteLingualityKind.MultiLingual;
const hasLocaleInUrls = siteLanguageConfig.kind === SiteLingualityKind.MultiLingual
    ? siteLanguageConfig.hasLocalesInUrls
    : false;

function getCurrentLocale(): Locale {
    return isMultiLingualSite
        ? appLocale.locale
        : getCookie('superbetLocale') as Locale || Locale.English;
}

export const SiteLanguageConfig = {
    hasLanguageSwitcher,
    isMultiLingualSite,
    hasLocaleInUrls,
    availableLocales: siteLanguageConfig.locales,
    currentLocale: getCurrentLocale(),
};
